import { z } from "zod";

export const truckSchema = z.object({
  id: z.number(),
  licence: z.string(),
  capacity: z.number(),
  title: z.string(),
  driver: z.object({
    id: z.number(),
    name: z.string(),
    label: z.string(),
    username: z.string(),
  }),
});
